import { ProductInfo } from "src/model/ProductMatch";
import React from "react";
import { KatButton, KatLink, KatBox, KatLabel } from "@amzn/katal-react";
import { WithTranslation, withTranslation } from "react-i18next";

export interface ProductItemProps {
    product: ProductInfo,
    handleSelect: Function
}

type Props = ProductItemProps & WithTranslation;

export class ProductItemComponent extends React.Component<Props, {}> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        const { t, product } = this.props;

        return (
            <>
                <KatBox id="product-item" variant="white" className={window.innerWidth > 1440 ? 'product-box' : 'product-box-slim'} >
                    <img src={product.thumbStringUrl} className="product-image" title={product.merchantSku ? "SKU:" + product.merchantSku : ""}/>
                    <KatLink label={product.title} href={product.link} variant="link" target="_blank" className="product-link" />
                    <KatLabel text={t('SC_FBA_Calc_productInfo_ASIN') + ': ' + product.asin} className="asin-line" />
                    <KatButton label={t('SC_FBA_Calc_btnSelect')} variant="secondary" className="select-button"
                        onClick={() => this.props.handleSelect(this.props.product)} />
                </KatBox>
            </>
        );
    }
}

export default withTranslation()(ProductItemComponent);